import { get } from 'common';

const CINEMA_ROUTE = `${process.env.REACT_APP_API_CONFIG}cinemas`;

export class CinemaService {
    private static instance: CinemaService;

    static getInstance(): CinemaService {
        if (!this.instance) {
            this.instance = new CinemaService();
        }

        return this.instance;
    }

    async findAll() {
        return await get(`${CINEMA_ROUTE}/`);
    }

    async findOne(id: number) {
        return await get(`${CINEMA_ROUTE}/${id}`);
    }
}
